/* Posterized - calm mode (Arjun 18-09 evening: "mobile heat and lag aaguratha stop paniye aaganum").
   Measured on live v74 at phone size: the review reels (the pack pages' video-carousel section and the
   builders' reels row) played the ORIGINAL uploads - 2160x3840, 30-180 MB each - three or four at a time
   inside rows that auto-scrolled for ever, and on the builders they kept playing behind the open picker;
   endless CSS animations kept repainting while nobody could see them.
   1. pzReels(track): every <video data-src=".../videos/c/o/v/<id>.mp4"> in the row gets Shopify's 480p copy of
      the same video (3-7 MB) and its first frame as the poster. ONE video plays at a time - the most visible
      one - and none while the picker is open (html.pz-wb-lock) or the tab is hidden. The rows are swiped now;
      they no longer scroll by themselves (that CSS lives with each row).
   2. Every endless CSS animation is paused while its element is off screen, and everything outside the picker
      is paused while the picker is open. Only animations this file paused are resumed. */
(function () {
  if (window.pzReels) return;
  var html = document.documentElement;
  function picking() { return html.classList.contains('pz-wb-lock'); }

  /* ---------- 1. review reels ---------- */
  /* video id -> [Shopify's 480p rendition, preview-image version] (Files API, 18-09) */
  var R = {"f987827d1f494baa97a9564493262051":["SD-480p-0.9Mbps-50139578","1751003907"],"003287e042a445159b0ea5dd26bf2d4d":["SD-480p-0.9Mbps-50139580","1751003909"],"ae04231f89fe4f5a927e145e7af37285":["SD-480p-0.9Mbps-50139579","1751003912"],"c498f76c4cec4866bdcdec4644cd2fd2":["SD-480p-0.9Mbps-50139577","1751003938"],"73c4e1e8fdce41ccbd817080e574a154":["SD-480p-0.9Mbps-50149063","1751014647"],"64c2db02cc17470f9c5977e40c650829":["SD-480p-0.9Mbps-50149060","1751014710"],"10b507a60f654acd82c6722cab12eb3d":["SD-480p-0.9Mbps-50149065","1751014718"],"41bcd825a48c4651b468d1e8f7678920":["SD-480p-0.9Mbps-50149062","1751014731"],"d3e095efe39c4f5ab7833ba05a6ec8b6":["SD-480p-0.9Mbps-50149069","1751014739"],"ee0b6075078f49eb8a50cc2a6f0a9afc":["SD-480p-0.9Mbps-50149068","1751014741"],"d584b7bc18c64e9e8bae04dc32025086":["SD-480p-0.9Mbps-50149064","1751014739"],"0e072b3ac4d34c029f25097e127588f3":["SD-480p-0.9Mbps-50149067","1751014748"],"620f51360be748979fa05d8b2050e8e8":["SD-480p-1.5Mbps-92225179","1787297636"],"b5d52a24f0b343ce99dd17ae1c403341":["SD-480p-1.5Mbps-92225198","1787297656"],"51031ae4616940c489d8918391d2fbb1":["SD-480p-1.5Mbps-92225218","1787297672"],"199683807f9843eba6aa06b594a99bca":["SD-480p-1.5Mbps-92225227","1787297674"],"621ec27748284d2baf2519a84fb413ed":["SD-480p-1.5Mbps-92225239","1787297720"],"3de453b593cd4f98abda70ffae4f4f9e":["SD-480p-1.5Mbps-92225236","1787297707"],"05114663cbaf4a768de16addb601d175":["SD-480p-1.5Mbps-92225237","1787297733"],"9818d7d49621418eae5225c56bb4dd4e":["SD-480p-1.5Mbps-92225663","1787297834"]};
  var VID = 'https://cdn.shopify.com/videos/c/vp/';
  var PST = 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/preview_images/';
  function lite(v) {
    var u = v.getAttribute('data-src') || '';
    var m = /([0-9a-f]{32})\.mp4/.exec(u), e = m && R[m[1]];
    if (e) {
      v.setAttribute('data-src', VID + m[1] + '/' + m[1] + '.' + e[0] + '.mp4');
      if (!v.getAttribute('poster')) v.setAttribute('poster', PST + m[1] + '.thumbnail.0000000000.jpg?v=' + e[1] + '&width=400');
    }
    v.muted = true; v.loop = true; v.preload = 'none';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
  }
  var groups = [];
  /* the most visible video of the row plays (a tie goes to the first); every other one is paused */
  function choose(g) {
    var best = null, top = 0.55;
    if (!document.hidden && !picking()) {
      for (var i = 0; i < g.v.length; i++) { var r = g.v[i].__pzR || 0; if (r > top) { top = r; best = g.v[i]; } }
    }
    for (var j = 0; j < g.v.length; j++) {
      var v = g.v[j];
      if (v === best) {
        if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) v.pause();
    }
  }
  /* returns false when it cannot run (no IntersectionObserver) - the caller keeps its own old behaviour */
  function pzReels(track) {
    if (!track || !('IntersectionObserver' in window)) return false;
    if (track.__pzReels) return true;
    track.__pzReels = true;
    var g = { v: [].slice.call(track.querySelectorAll('video')) };
    g.v.forEach(lite);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { en.target.__pzR = en.isIntersecting ? en.intersectionRatio : 0; });
      choose(g);
    }, { threshold: [0, 0.3, 0.6, 0.8, 1] });
    g.v.forEach(function (v) { io.observe(v); });
    groups.push(g);
    return true;
  }
  window.pzReels = pzReels;

  /* ---------- 2. endless CSS animations ---------- */
  var aio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { en.target.__pzOn = en.isIntersecting; sync(en.target); });
  }, { rootMargin: '80px' }) : null;
  var watched = [];
  function sync(el) {
    var list = el.__pzA;
    if (!list) return;
    var run = el.__pzOn !== false && !(picking() && !(el.closest && el.closest('.pz-wb-drawer')));
    for (var i = list.length - 1; i >= 0; i--) {
      var a = list[i], s = a.playState;
      if (s === 'idle' || s === 'finished') { list.splice(i, 1); continue; }
      try {
        if (run) { if (a.__pzPaused && s === 'paused') { a.__pzPaused = false; a.play(); } }
        else if (s === 'running') { a.__pzPaused = true; a.pause(); }
      } catch (e) {}
    }
  }
  function watch(a) {
    var ef = a && a.effect, el = ef && ef.target;
    if (!aio || !el || !(el instanceof Element) || !ef.getTiming) return;
    try { if (ef.getTiming().iterations !== Infinity) return; } catch (e) { return; }
    if (!el.__pzA) { el.__pzA = []; watched.push(el); aio.observe(el); }
    if (el.__pzA.indexOf(a) < 0) { el.__pzA.push(a); sync(el); }
  }
  function scan() { try { if (document.getAnimations) document.getAnimations().forEach(watch); } catch (e) {} }
  function syncAll() {
    for (var i = watched.length - 1; i >= 0; i--) {
      var el = watched[i];
      if (!el.isConnected) { try { aio.unobserve(el); } catch (e) {} watched.splice(i, 1); continue; }
      sync(el);
    }
    groups.forEach(choose);
  }
  if (aio) {
    document.addEventListener('animationstart', function (e) {
      var t = e.target;
      if (t && t.getAnimations) { try { t.getAnimations({ subtree: !!e.pseudoElement }).forEach(watch); } catch (x) {} }
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
    window.addEventListener('load', scan);
  }
  /* the picker opening / closing is a class on <html> (pz-wb-lock) */
  if (window.MutationObserver) new MutationObserver(syncAll).observe(html, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('visibilitychange', function () { groups.forEach(choose); });
})();
